import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PropTypes from 'prop-types';

const AAFModalSentLink = (props = {}) => {
  const title = Translator.get('resendLink_modal_title_label','Está en camino un link para ti');
  const content = Translator.get('resendLink_modal_description_label','Este podría tardar hasta 10 minutos en llegar');

  const p = {
    content,
    title,
    alwaysEnabled: true,
    buttonsAlign: 'vertical',
    buttons: [
      {
        content: Translator.get('resendLink_modal_option_button_getNewPassword', 'Obtener nueva contraseña'),
        props: {
          onClick: (e) => {props.handleClose(e, props.callback);},
          className: 'aaf-modal-button aaf-modal-button-primary'
        }
      },
      {
        content: Translator.get('resendLink_modal_option_button_close', 'CERRAR'),
        props: {
          onClick: (e) => {props.handleClose(e, props.onClose);},
          className: 'aaf-modal-button aaf-modal-button-primary',
          variant: 'dark'
        }
      }
    ],
    aafNewStyle: true,
    className: 'aaf-modal',
    showLogo: false,
  };
  return <ModalWrapper {...p} />;
};

AAFModalSentLink.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
};

export default withOnClose(AAFModalSentLink);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalSentLink.jsx